<template>
    <div :class="{ focused: isFocused }">
        <label
            v-if="label"
            class="vs-input--label"
            :for="inputId"
            @click="focus"
            v-html="label_text"
        />
        <div class="vx-date-range-input flex flex-nowrap w-full items-center justify-center">
            <vx-date-input
                :id="inputId"
                :label="startLabel"
                :disabled-dates="disabledStartDates"
                v-model="start"
                ref="startInput"
                class="w-full"
                remove-validation-padding
                :danger="hasValidationErrors"
                @blur="startFocused = false"
                @focus="startFocused = true"
            />
            <vx-basic-icon
                class="mx-4"
                icon="ArrowRightIcon"
                size="6"
                style="width: 42px"
                :style="{
                    marginTop: startLabel || endLabel ? '21px' : '0px'
                }"
            />
            <vx-date-input
                v-model="end"
                :label="endLabel"
                :disabled-dates="disabledEndDates"
                ref="endInput"
                class="w-full"
                remove-validation-padding
                :danger="hasValidationErrors"
                @blur="endFocused = false"
                @focus="endFocused = true"
            />
        </div>
        <vx-validation-message />
    </div>
</template>

<script>
import ValidationMixins from '@/plugins/validation/mixins'
export default {
    name: 'vx-date-range-input',
    mixins: [ValidationMixins],
    props: {
        value: {
            type: Object,
            default: function () {
                return {
                    start: null,
                    end: null
                }
            }
        },
        label: {
            type: String
        },
        startLabel: {
            type: String
        },
        endLabel: {
            type: String
        }
    },
    data() {
        return {
            startFocused: false,
            endFocused: false
        }
    },
    computed: {
        inputId() {
            return `${this._uid}-input`
        },
        // startFocused() {
        //     return this.$refs.startInput && this.$refs.startInput.focused
        // },
        // endFocused() {
        //     return this.$refs.endInput && this.$refs.endInput.focused
        // },
        disabledEndDates() {
            if (!this.start) {
                return null
            }
            return [
                {
                    start: null,
                    end: this.start
                }
            ]
        },
        disabledStartDates() {
            if (!this.end) {
                return null
            }
            return [
                {
                    start: this.end,
                    end: null
                }
            ]
        },
        isFocused() {
            return this.startFocused || this.endFocused
        },
        start: {
            get() {
                return this.value && this.value.start
            },
            set(v) {
                this.$emit('input', {
                    start: v,
                    end: this.end
                })
            }
        },
        end: {
            get() {
                return this.value && this.value.end
            },
            set(v) {
                this.$emit('input', {
                    start: this.start,
                    end: v
                })
            }
        }
    },
    methods: {
        focus() {
            this.$refs.startInput.focus()
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/vuexy/_variables.scss';

.focused {
    label {
        color: $primary !important;
    }
}
</style>
